import { render, staticRenderFns } from "./ExecVoc.vue?vue&type=template&id=3a24ab5c"
import script from "./ExecVoc.vue?vue&type=script&lang=js"
export * from "./ExecVoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports